import React, { useEffect, useState } from 'react';
import { Promotion, RewardDeliveryType } from '../Promotion.model';
import { ClaimDirectReward } from './ClaimDirectReward';
import { ClaimPromoCodeReward } from './ClaimPromoCodeReward';

interface Props {
  promotion: Promotion;
  provider?: string;
  previousStep: () => void;
}

export function ClaimReward({ promotion, provider, previousStep }: Props): JSX.Element {
  const [rewardDeliveryType, setRewardDeliveryType] = useState<RewardDeliveryType>(null);

  useEffect(() => {
    setRewardDeliveryType(promotion.promotionData.rewardDeliveryType);
  }, [promotion]);

  return (
    <>
      {rewardDeliveryType === RewardDeliveryType.Promocode
      && <ClaimPromoCodeReward promotion={promotion} />}
      {rewardDeliveryType === RewardDeliveryType.Direct
      && <ClaimDirectReward promotion={promotion} provider={provider} previousStep={previousStep} />}
    </>
  );
}
